var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-skeleton',{staticClass:"monitoring-skeleton",attrs:{"animated":""}},[_c('template',{slot:"template"},[_c('el-skeleton-item',{attrs:{"variant":_vm.variant}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }